import { AssetsOccupationModel } from '../models/assetsModel';

export const AssetsOccupationStatisticsEntity = ({
  assetsLinkedToUsers,
  assetsNotLinkedToUsers,
  totalAssets,
}: AssetsOccupationModel): Readonly<AssetsOccupationModel> => {
  return Object.freeze({ assetsLinkedToUsers, assetsNotLinkedToUsers, totalAssets });
};
